/**
 * Sample page JS provided here for extension. Might not be useful if all JS is based on components.
 */
class Tabs extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
  }

  onReady(document) {
    this.tabs();
  }

  tabs() {
    $('.tab-nav li:first-child a').tab('show');
    $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      $('.tab-content .tab').removeClass('active');
    })
  }
}

DrupalBehavior.register('psh_theme.components', 'tabs', Tabs);
